// src/components/HomePage.jsx
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const currentYear = new Date().getFullYear();
  const APP_VERSION = __APP_VERSION__;

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* Header */}
      <header className="bg-white border-bottom py-3 shadow-sm">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="text-primary fs-3">
                <i className="bi bi-clipboard-check"></i>
              </div>
              <div className="ms-3">
                <h5 className="mb-0 text-primary fw-bold">НЕЗАВИСИМАЯ ОЦЕНКА КАЧЕСТВА</h5>
                <small className="text-muted">Портал</small>
              </div>
            </div>
            <div>
              <Link to="/login" className="btn btn-outline-primary me-2">
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Войти
              </Link>
              {/* <Link to="/login" className="btn btn-primary">
                <i className="bi bi-person-plus me-2"></i>
                Регистрация
              </Link> */}
            </div>
          </div>
        </Container>
      </header>

      {/* Hero Section */}
      <section className="bg-primary-gradient text-white py-5">
        <Container>
          <Row className="align-items-center py-5">
            <Col lg={6}>
              <h1 className="display-5 fw-bold mb-4">
                Независимая оценка качества медицинских услуг
              </h1>
              <p className="lead mb-4 opacity-90">
                Портал для проведения опросов и оценки качества условий оказания услуг медицинскими организациями. Участвуйте в создании прозрачной и эффективной системы здравоохранения.
              </p>
              <div className="d-flex gap-3">
                {/* <Link to="/login" className="btn btn-light btn-lg px-4">
                  <i className="bi bi-play-circle me-2"></i>
                  Начать оценку
                </Link> */}
                {/* <Link to="/about" className="btn btn-outline-light btn-lg px-4">
                  <i className="bi bi-info-circle me-2"></i>
                  О системе
                </Link> */}
              </div>
            </Col>
            <Col lg={6} className="mt-4 mt-lg-0">
              {/* <div className="bg-white rounded-4 p-3 shadow-lg">
               
              </div> */}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section
      <section className="py-5 bg-white">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3">Основные возможности</h2>
            <p className="text-muted lead">Вся необходимая функциональность для проведения оценки качества</p>
          </div>
          <Row className="g-4">
            <Col md={4}>
              <Card className="border-0 shadow-sm h-100 text-center">
                <Card.Body className="p-4">
                  <div className="text-primary mb-3">
                    <i className="bi bi-clipboard-data display-5"></i>
                  </div>
                  <h5 className="fw-bold mb-3">Онлайн опросы</h5>
                  <p className="text-muted">
                    Современные цифровые анкеты для оценки качества медицинских услуг
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="border-0 shadow-sm h-100 text-center">
                <Card.Body className="p-4">
                  <div className="text-primary mb-3">
                    <i className="bi bi-shield-check display-5"></i>
                  </div>
                  <h5 className="fw-bold mb-3">Конфиденциальность</h5>
                  <p className="text-muted">
                    Полная анонимность и защита персональных данных респондентов
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="border-0 shadow-sm h-100 text-center">
                <Card.Body className="p-4">
                  <div className="text-primary mb-3">
                    <i className="bi bi-graph-up-arrow display-5"></i>
                  </div>
                  <h5 className="fw-bold mb-3">Аналитика</h5>
                  <p className="text-muted">
                    Детальные отчеты и статистика по результатам оценки качества
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

   
      <section className="py-5 bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} className="text-center">
              <div className="bg-primary text-white rounded-4 p-5 shadow">
                <h2 className="fw-bold mb-3">Начните оценивать качество прямо сейчас</h2>
                <p className="mb-4 opacity-90">
                  Ваше мнение помогает улучшать систему здравоохранения. Присоединяйтесь к программе независимой оценки качества.
                </p>
                <Link to="/login" className="btn btn-light btn-lg px-5">
                  <i className="bi bi-arrow-right-circle me-2"></i>
                  Присоединиться
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      {/* Footer */}
      <footer className="bg-dark text-white py-4 mt-auto">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="text-white fs-3 me-3">
                  <i className="bi bi-clipboard-check"></i>
                </div>
                <div>
                  <h6 className="mb-0 fw-bold">Портал независимой оценки качества</h6>
                  <small className="text-white-50">Медицинские организации</small>
                </div>
              </div>
            </Col>
            <Col md={6} className="text-end">
              <p className="text-white-50 small mb-0">
                <a href="https://hakster.ru" className="hs-brand">HAKSTER</a>
                 © {currentYear} Система независимой оценки качества 
                <span className="ms-2">v{APP_VERSION}</span>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default HomePage;